module.exports = __webpack_public_path__ + "static/media/microsoft-excebl.7b2550cd.png";